export default function React_Lists() {
  return (
    <div>
      <h1>React_Lists Component</h1>
      <p>This is the React_Lists tutorial page.</p>
    </div>
  );
}
